import styled from '@emotion/styled'

import type { RootStylesType } from '../types'

type StyledMenuLabelProps = RootStylesType & {
  textTruncate?: boolean
  isHover?: boolean
}

const StyledMenuLabel = styled.span<StyledMenuLabelProps>`
  flex-grow: 1;
  text-overflow: ellipsis;
  overflow: hidden;

  ${({ textTruncate, isHover }) => {
    if (textTruncate) {
      if (isHover) {
        return `
          white-space: nowrap;
        `
      } else {
        return `
          white-space: normal;
        `
      }
    }

    return ''
  }};
  ${({ rootStyles }) => rootStyles};
`

export default StyledMenuLabel

// // Third-party Imports
// import styled from '@emotion/styled'

// // Type Imports
// import type { RootStylesType } from '../types'

// type StyledMenuLabelProps = RootStylesType & {
//   textTruncate?: boolean
//   isHover?: boolean
// }

// const StyledMenuLabel = styled.span<StyledMenuLabelProps>`
//   flex-grow: 1;
//   ${({ textTruncate, isHover }) => {
//     let styles = ''

//     if (textTruncate) {
//       styles += `
//         text-overflow: ellipsis;
//         overflow: hidden;
//       `

//       if (isHover) {
//         styles += `
//           white-space: nowrap;
//         `
//       }
//     }

//     return styles
//   }};
//   ${({ rootStyles }) => rootStyles};
// `

// // const StyledMenuLabel = styled.span<StyledMenuLabelProps>`
// //   flex-grow: 1;
// //   ${({ textTruncate }) =>
// //     textTruncate &&
// //     `
// //       text-overflow: ellipsis;
// //       overflow: hidden;
// //       white-space: nowrap;
// //     `};
// //   ${({ rootStyles }) => rootStyles};
// // `

// // const StyledMenuLabel = styled.span<StyledMenuLabelProps>`
// //   flex-grow: 1;
// //   ${({ textTruncate }) => textTruncate};
// //   ${({ rootStyles }) => rootStyles};
// // `

// export default StyledMenuLabel
